import { Fetcher } from '@this/src/util';

type ArrangementResponse = {
  success: boolean;
  order_id?: number;
  error?: string;
};

export type ArrangementResult = {
  success: boolean;
  orderId?: number;
  error?: string;
};

const convertResponse = (response: ArrangementResponse): ArrangementResult => ({
  success: response.success,
  orderId: response.order_id,
  error: response.error
});

export const createArrangement = async (tripId: string): Promise<ArrangementResult> => {
  const response = await Fetcher.post<ArrangementResponse>(`/trips/${tripId}/ai_arrangements`, {});
  return convertResponse(response);
};
